import momentTimezone from "moment-timezone";
import { ConfigLocalKey } from "../context/configContext";
import { getLocalStorage } from "./storageUtil";

import momentMain from "moment";
import "moment/min/locales";

export const defaultTimezone = "Asia/Kolkata";
export const defaultLocale = "en-in";

export const moment = (
  input,
  overridedTimeZone = null,
  overridedLocale = null
) => {
  const { timezone, locale } = getLocalStorage(ConfigLocalKey);
  const _timezone = overridedTimeZone || timezone || defaultTimezone;
  const _locale = overridedLocale || locale || defaultLocale;

  momentMain.locale(_locale);
  const _moment = momentMain(input);

  const m = momentTimezone.tz(_moment, _timezone);

  if (_timezone === "CET" || _timezone.includes("Europe")) {
    m.customFormat = () => m.format("DD MMM, YYYY");
  } else {
    m.customFormat = () => m.format("MMM DD, YYYY");
  }

  return m;
};

export default moment;
